import trim from 'lodash/trim'
// @ts-ignore
import scrollIntoView from 'scroll-into-view-if-needed';
import type { HighlightItemInfo } from './nexus'
type Ele = HTMLElement;

let _focusedNode:Ele|undefined

export default class ScrollToHighlightHelper {
    public scopeSelector: string
    public currentFocusClass: string
    constructor(scopeSelector:string) {
        this.scopeSelector = scopeSelector;
        this.currentFocusClass = 'patsnap-mark-current-focus'
    }

    get focusedNode() {
        return _focusedNode
    }

    set focusedNode(node:Ele|undefined) {
        this.focus(node, true);
        this.focus(_focusedNode, false);
        _focusedNode = node;
    }

    focus(node:Ele|undefined, bol:boolean) {
        if (node) {
            node.classList[bol ? 'add' : 'remove'](this.currentFocusClass)
        }
    }

    findNodeCallback(node:Ele, lastNode: Ele|undefined, classname:string):Boolean {
        return true // 返回false不执行
    }

    getNodeArrayByValue(
        value:HighlightItemInfo['value'],
        scopeElementGetter: () => HTMLElement = () => document.body
    ):Array<Ele> {
        if (!value) return [];
        function reducer(acumulador:Array<string>, keyword) {
            // @ts-ignore
            const trimdKw = trim(keyword);
            if (trimdKw) {
                return acumulador.concat([`[data-keyword="${trimdKw}"]`])
            } else {
                return acumulador
            }
        }
        const selectors = value.split(';').reduce(reducer, [])

        return Array.from(scopeElementGetter().querySelectorAll(selectors.join(',')))
    }

    * getElementScrollerByInputValue(originalValue) {
        const self = this;
        if (typeof originalValue !== 'string') {
            throw new TypeError(`getElementScrollerByKeyword: ${originalValue} is not a string`);
        }
        function getNodeArray() {
            return self.getNodeArrayByValue(originalValue);
        }
        let nodeArray = getNodeArray()

        let idx = 0;
        while (true) {
            nodeArray = nodeArray[idx] ? nodeArray : getNodeArray();
            let node = nodeArray[idx];
            if (!node) {
                // 到顶部会到最后一个
                idx = idx < 0 ? nodeArray.length - 1 : 0;
                node = nodeArray[idx];
            }
            if (node) {
                const allowToScroll = self.findNodeCallback(node, self.focusedNode, self.currentFocusClass)
                if (allowToScroll !== false) {
                    self.scrollTo(node);
                    self.focusedNode = node;
                }
            } else {
                yield undefined;
            }
            const delta:number = yield node;
            // script 从这里往下运行
            idx = idx + (delta || 0);
        }
    }

    scrollTo(node) {
        scrollIntoView(node, {
            scrollMode: 'if-needed',
            inline: 'end',
            block: 'nearest',
            behavior: 'smooth'
        });
    }

    destory() {
        this.focusedNode = undefined;
    }
}
